<template>
    <div class="searchColor">
        <div class="color-item" v-for="(item,index) in washProductColorList" :key="index" @click="onColor(item)">
            <div class="color" :style="'background-color:'+ item.colorCode"></div>
            {{ item.colorName }}
        </div>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    data() {
        return {
            washProductColorList: []
        };
    },
    mounted() {
        this.getWashProductColorList();
    },
    methods: {
        // 获取全部颜色
        getWashProductColorList() {
            get('/wash/utils/findAllWashProductColor').then((res) => {
                if (res.success) {
                    this.washProductColorList = res.list;
                }
            });
        },

        // 点击了颜色
        onColor(colorItem){
            this.$emit("onColor",colorItem)
        }
    }
};
</script>

<style scoped lang="scss">
.searchColor {
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .color-item{
        display: inline-block;
        margin:  0 0 10px 10px;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;

        .color{
            display: inline-block;
            width: 14px;
            height: 14px;
        }
    }
}
</style>